var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('img',{staticClass:"img-fluid",attrs:{"src":require('@/assets/images/offers/' + _vm.img),"alt":"#"}})])}
var staticRenderFns = []

export { render, staticRenderFns }